/**
 * Godo canonical dates — always "dd/mm/yyyy HH:mm" (never ISO for API).
 */

const GODODATE_PATTERN =
  /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})$/;

export function isGodoDate(value: string): boolean {
  return GODODATE_PATTERN.test(value.trim());
}

export function parseGodoDate(value: string): Date {
  const m = GODODATE_PATTERN.exec(value.trim());
  if (!m) throw new Error(`expected dd/mm/yyyy HH:mm, got "${value}"`);
  const day = Number(m[1]);
  const month = Number(m[2]);
  const year = Number(m[3]);
  const hour = Number(m[4]);
  const minute = Number(m[5]);
  return new Date(year, month - 1, day, hour, minute, 0, 0);
}

/** Format Date → canonical string for API payloads (local wall clock). */
export function formatGodoDate(date: Date): string {
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = String(date.getFullYear());
  const hh = String(date.getHours()).padStart(2, "0");
  const min = String(date.getMinutes()).padStart(2, "0");
  return `${dd}/${mm}/${yyyy} ${hh}:${min}`;
}

/** Format for `<input type="datetime-local">` value (YYYY-MM-DDTHH:mm). */
export function toDatetimeLocalValue(godoDate: string): string {
  const m = GODODATE_PATTERN.exec(godoDate.trim());
  if (!m) return "";
  return `${m[3]}-${m[2]}-${m[1]}T${m[4]}:${m[5]}`;
}

/** Parse datetime-local input → canonical Godo string (NOT ISO). */
export function fromDatetimeLocalValue(value: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(value.trim());
  if (!m) throw new Error("invalid datetime-local value");
  return `${m[3]}/${m[2]}/${m[1]} ${m[4]}:${m[5]}`;
}

export function nowGodoDate(): string {
  return formatGodoDate(new Date());
}
